import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { appVersionKeys } from '../query-keys';
import { appVersionContract, type AppVersionResponse } from '@bliks-io/contracts';

export function useAppVersion() {
  return useQuery({
    queryKey: appVersionKeys.all,
    queryFn: async ({ signal }): Promise<AppVersionResponse> => {
      const { data } = await apiClient.get<AppVersionResponse>(appVersionContract.path, { signal });
      return data;
    },
    staleTime: Infinity
  });
}
